import { z } from 'zod';

// Shape guard, not an allow-list: legitimate ids aren't statically enumerable.
// `FieldId` is replayed as a lodash `_.set()` path — see packages/web/CLAUDE.md.

const UNSAFE_FIELD_ID_SEGMENTS = new Set([
  '__proto__',
  'constructor',
  'prototype',
]);

const MAX_FIELD_ID_LENGTH = 200;

const ALLOWED_FIELD_ID_CHARS = /^[A-Za-z0-9_.-]+$/;

export const isSafeFieldId = (id: string): boolean => {
  if (id.length === 0 || id.length > MAX_FIELD_ID_LENGTH) {
    return false;
  }
  if (!ALLOWED_FIELD_ID_CHARS.test(id)) {
    return false;
  }

  return id
    .split('.')
    .every(
      (segment) => segment.length > 0 && !UNSAFE_FIELD_ID_SEGMENTS.has(segment)
    );
};

export const FIELD_ID_ERROR_MESSAGE =
  `FieldId must be 1-${MAX_FIELD_ID_LENGTH} characters of letters, digits, \`_\`, \`-\` or \`.\`, ` +
  `with no empty dot segment and no segment named ` +
  `${[...UNSAFE_FIELD_ID_SEGMENTS].map((s) => `\`${s}\``).join(', ')}`;

export const fieldIdSchema = z
  .string()
  .min(1, 'FieldId is required')
  .refine(isSafeFieldId, FIELD_ID_ERROR_MESSAGE);
